<ng-container #productMapHost></ng-container>
